import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@achra/ui/skeleton';
function OperatorKeyPointSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="border-border bg-popover flex flex-col gap-2 rounded-lg border p-2"><Skeleton className="h-4.5 w-full max-w-16" /><Skeleton className="h-5.5 w-full max-w-24" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export { OperatorKeyPointSkeleton };